import template from './topdata-convert-customer-modal.html.twig';
import './topdata-convert-customer-modal.scss';

const { Application } = Shopware;

export default {
    template,

    data() {
        return {
            sourceCustomerNumber: '',
            targetCustomerNumber: '',
            deleteContacts: false,
            isLoading: false,
        };
    },

    computed: {
        isValid() {
            return this.sourceCustomerNumber.trim() !== '' && this.targetCustomerNumber.trim() !== '';
        }
    },

    methods: {
        onClose() {
            this.$emit('modal-close');
        },

        onConfirm() {
            if (!this.isValid) {
                return;
            }

            this.isLoading = true;
            const httpClient = Application.getContainer('init').httpClient;

            httpClient.post('_action/topdata-contact-login-sw6/convert-customer', {
                sourceCustomerNumber: this.sourceCustomerNumber.trim(),
                targetCustomerNumber: this.targetCustomerNumber.trim(),
                deleteContacts: this.deleteContacts,
            })
            .then((response) => {
                this.isLoading = false;
                const data = response.data;

                if (data.success) {
                    this.$emit('conversion-success', data);
                } else {
                    this.$emit('conversion-error', data.message || 'Unknown error');
                }
            })
            .catch((error) => {
                this.isLoading = false;
                const message = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'A connection error occurred';

                this.$emit('conversion-error', message);
            });
        }
    }
};
